import { call, put, takeLatest, CallEffect, PutEffect } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import api from 'src/services/graphicsApi';
import { actions, BundledPlaylistGraphicsType } from '../reducers/bundledPlaylistGraphic';

type BundledPlaylistGraphicsApiResponse = void | {
  data: BundledPlaylistGraphicsType;
  status: number;
};

function* getBundledPlaylistGraphics(
  action: PayloadAction<{ rundownId: string }>
): Generator<CallEffect | PutEffect, void, BundledPlaylistGraphicsApiResponse> {
  try {
    const { rundownId } = action.payload;
    const response = yield call(
      api.get,
      `/rundowns/${rundownId}/playlistGraphics?filter[type]=bundle`);

    if (response?.data) {
      yield put(actions.receiveGetBundledPlaylistGraphics(response.data));
    }
  } catch (error) {
    yield put(
      actions.failedGetBundledPlaylistGraphics(
        'Something went wrong getting bundled playlist graphics'
      )
    );
  }
}

export default function* root() {
  yield takeLatest(actions.requestGetBundledPlaylistGraphics.type, getBundledPlaylistGraphics);
}
